import { cloneDeep } from 'lodash';
import { v5 as uuidV5 } from 'uuid';
import { AbstractEntity } from "../AbstractEntity";
import Book from "../book/Book";
import Signature from "../Signature";
import { User } from "../usercontrol";
import { getUtcNow } from "../../utils";
import ProtocolContent from './ProtocolContent';
import ProtocolContentType from './ProtocolContentType';
export default class Protocol extends AbstractEntity {
    static createAmendment(protocol, author, deleted) {
        const amendment = new Protocol({
            timestamp: protocol.timestamp,
            author: User.createRef(author._id),
            type: cloneDeep(protocol.type),
            contents: protocol.contents.map((c) => new ProtocolContent({ type: ProtocolContentType.createRef(c.type._id), data: cloneDeep(c.data) })),
            books: protocol.books,
            position: protocol.position,
            sogCog: protocol.sogCog,
            predecessor: Protocol.createRef(protocol._id),
            deleted,
        });
        amendment.files = protocol.files;
        return amendment;
    }
    static createFromDraft(draft, author) {
        if (!draft.isDrafted) {
            throw new Error('this is not a draft.');
        }
        const protocol = new Protocol({
            timestamp: draft.timestamp,
            author: User.createRef(author._id),
            type: cloneDeep(draft.type),
            contents: draft.contents.map((c) => new ProtocolContent({ type: ProtocolContentType.createRef(c.type._id), data: c.data })),
            books: draft.books,
            position: draft.position,
            sogCog: draft.sogCog,
        });
        protocol.files = draft.files;
        return protocol;
    }
    gatewayAmendmentId;
    createdTimestamp = getUtcNow();
    timestamp;
    author;
    type;
    contents;
    books;
    position;
    sogCog;
    predecessor;
    deleted;
    reasonForChange;
    isDrafted = false;
    clientDeviceId;
    signature;
    firstApproved = false;
    secondApproved = false;
    files = [];
    isDecrypting;
    constructor(protocol = {}) {
        super();
        Object.assign(this, protocol);
        this.gatewayAmendmentId = createGatewayAmendmentId(this);
    }
}
export function createGatewayAmendmentId(protocol) {
    if (!protocol.deleted && protocol.predecessor) {
        return transformProtocolIdForAmendment(protocol._id);
    }
    return protocol._id;
}
export function transformProtocolIdForAmendment(id) {
    return uuidV5('amendment', id);
}
//# sourceMappingURL=Protocol.js.map